// extracted by mini-css-extract-plugin
module.exports = {"passGuaranteeContainer":"PassGuaranteeComponent_passGuaranteeContainer__ikh_r","title":"PassGuaranteeComponent_title___upRL"};